/**
 * Register Page
 * Full page component for user registration
 */

import React from 'react';
import { motion } from 'framer-motion';
import { RegisterForm } from '../components/auth/RegisterForm';
import SEO from '../components/common/SEO';

const RegisterPage: React.FC = () => {
  return (
    <>
      <SEO
        title="สมัครสมาชิก | Thai Security Directory"
        description="สร้างบัญชีใหม่เพื่อเข้าถึงฟีเจอร์ทั้งหมดของ Thai Security Directory"
        url="/register"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col justify-center py-12 sm:px-6 lg:px-8"
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              สมัครสมาชิก
            </h1>
            <p className="text-sm text-gray-600">
              สร้างบัญชีใหม่เพื่อเข้าถึงฟีเจอร์ทั้งหมดของ Thai Security Directory
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <RegisterForm />
        </div>
      </motion.div>
    </>
  );
};

export default RegisterPage;